import { createAction } from '@reduxjs/toolkit'

const PackageMaintenance = 'package-maintenance';
export const packageSaved = createAction(`${PackageMaintenance}/saved`);
export const packageDeleted = createAction(`${PackageMaintenance}/deleted`);